<p-sidebar
  *ngIf="{ visible: userSidebarVisible$ | async } as sidebar"
  [visible]="sidebar.visible"
  (visibleChange)="changeUserSidebarVisibleEvent.emit($event)"
  (onHide)="changeUserSidebarVisibleEvent.emit(false)"
  [transitionOptions]="'250ms cubic-bezier(0, 0, 0.2, 1)'"
  [closeOnEscape]="true"
  position="right"
>
  <app-progress-spinner
    position="absolute"
    [hidden]="!(loading$ | async)"
  ></app-progress-spinner>

  <div class="mb-3 pl-3">
    <h3>Change password</h3>
  </div>

  <!--
    Password only. Editing your details moved to /office/profile, a real page:
    this drawer is a modal with a full-screen mask, so it hid whatever you were
    reading, and a two-tab panel never fitted its own width — the fields ran off
    the edge. What is left is short enough to fit.
  -->
  <div class="px-3">
    <app-change-password
      (submitEvent)="passwordChangeEvent.emit($event)"
    ></app-change-password>

    <a
      class="account-actions__link mt-3"
      routerLink="/office/profile"
      (click)="changeUserSidebarVisibleEvent.emit(false)"
    >
      <i class="pi pi-user"></i>
      <span>Edit my profile</span>
    </a>
  </div>

  <!--
    Account actions live here, always visible, rather than three clicks deep
    inside a "Settings" tab. Sign out is the one control a person needs to find
    in a hurry on a shared device.
  -->
  <div class="account-actions">
    <a
      class="account-actions__link"
      routerLink="/office/security/mfa"
      (click)="changeUserSidebarVisibleEvent.emit(false)"
    >
      <i class="pi pi-shield"></i>
      <span>Security &amp; two-factor</span>
    </a>

    <button
      pButton
      type="button"
      class="p-button-outlined account-actions__signout"
      (click)="logoutEvent.emit()"
    >
      <i class="pi pi-sign-out"></i>
      <span class="ml-2">Sign out</span>
    </button>
  </div>
</p-sidebar>

